(function () {
  const isMedia = document.body.classList.contains("is-media-page");

  if (window.innerWidth < 1000 || isMedia) {
    const body = document.body;
    const navigation = document.getElementById("main-menu-wrapper");
    const navbar = document.getElementById("back-btn");
    const title = document.getElementById("main-menu-wrapper-header-title");
    const menu = document.getElementById("main-menu");
    const menuItems = menu?.querySelectorAll("a") || [];
    const toggles = document.querySelectorAll("[data-js-navigation-toggle]");
    const btnBack = document.getElementById("back-btn");
    const btnClose = document.getElementById("close-btn");
    if (!navigation || !navbar || !title || !menu) return;
    let currentLevel = 1;
    let menuStack = [];
    let titleStack = [];
    let currentMenu = null;

    const showNavigation = () => {
      navigation.dataset.visible = "true";
      navigation.dataset.open = "true";
      body.classList.add("menu-open");
      menu.dataset.open = "true"; 
    };

    const hideNavigation = () => {
      navigation.dataset.open = "false";
      body.classList.remove("menu-open");
      navigation.dataset.visible = "false";
      resetMenuState();
    };

    const showSubmenu = (subMenu, clickedTitle) => {
      if (!subMenu) return;

      currentLevel++;
      menuStack.push(currentMenu);
      titleStack.push(clickedTitle);

      currentMenu?.setAttribute("data-open", "true");
      currentMenu = subMenu;
      subMenu.setAttribute("data-open", "true");
      navbar.dataset.level = currentLevel;
      navbar.dataset.submenuOpen = "true";

      updateTitle(clickedTitle);
    };

    const hideSubmenu = () => {
      if (currentLevel === 1) return;

      const previousMenu = menuStack.pop();
      const previousTitle = titleStack.length > 0 ? titleStack[titleStack.length - 2] : "";

      currentLevel--;
      titleStack.pop();

      currentMenu?.setAttribute("data-open", "false");
      if (previousMenu) {
        previousMenu.setAttribute("data-open", "true");
      }

      currentMenu = previousMenu;
      navbar.dataset.level = currentLevel;
      navbar.dataset.submenuOpen = currentLevel > 1 ? "true" : "false";

      updateTitle(previousTitle);
    };

    const updateTitle = (newTitle) => {
      btnBack.dataset.title = newTitle || "";
    };

    const resetMenuState = () => {
      currentLevel = 1;
      menuStack = [];
      titleStack = [];
      currentMenu = null;
      navbar.dataset.level = "1";
      navbar.dataset.submenuOpen = "false";
      menu.dataset.open = "false";

      menu.querySelectorAll(".sub-menu").forEach(submenu => {
        submenu.setAttribute("data-open", "false");
      });

      updateTitle("");
    };

    btnBack?.addEventListener("click", hideSubmenu);
    btnClose?.addEventListener("click", hideNavigation);

    if ( toggles ) {
      toggles.forEach(toggle => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          
          showNavigation();
        });
      });
    }

    menuItems.forEach(item => {
      const hasSubMenu = item.nextElementSibling?.classList.contains("sub-menu");
      
      if (hasSubMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const subMenu = item.nextElementSibling;
          showSubmenu(subMenu, e.target.innerText);
        });
      }
    });
  }
})();